import { Pipe, PipeTransform } from '@angular/core';
import { DriverActivityStatus } from 'app/models';

@Pipe({
  name: 'getIconPercent',
})
export class GetIconPercentPipe implements PipeTransform {
  transform(driverStatus: DriverActivityStatus): string {
    if(driverStatus === DriverActivityStatus.OnTrip){
      return 'XpressApp/assets/images/small-icons/CheckCircleFilled.svg';
    }
    return 'XpressApp/assets/images/small-icons/CheckOrangeCircleFilled.svg';
  }
}
